module.exports = __webpack_public_path__ + "static/media/high_loss_dark.27e1c019.svg";